var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import * as THREE from 'three';
import Img from 'components/img';
// var OrbitControls = require('three-orbit-controls')(THREE)
var GLTFLoader = require('three-gltf-loader');
// var OrbitControls = require('three-orbitcontrols') 
var Scene = /** @class */ (function (_super) {
    __extends(Scene, _super);
    function Scene(props) {
        var _this = _super.call(this, props) || this;
        _this.styles = {
            sliderdiv: {
                float: 'left'
            }
        };
        _this.mount = React.createRef();
        // updateTextureEncoding (object:any) {
        //   const encoding = THREE.sRGBEncoding
        //   traverseMaterials(object, (material:any) => {
        //     if (material.map) material.map.encoding = encoding;
        //     if (material.emissiveMap) material.emissiveMap.encoding = encoding;
        //     if (material.map || material.emissiveMap) material.needsUpdate = true;
        //   });
        // }
        _this.loadModel = function (gltfmodel, scene, camera) {
            if (gltfmodel !== undefined || ' ') {
                var gltfloader = new GLTFLoader();
                gltfloader.load(gltfmodel, function (gltf) {
                    var mygeometry = new THREE.Geometry();
                    var myscene = gltf.scene || gltf.scenes[0];
                    var myscene1 = myscene;
                    _this.setContent(myscene);
                    _this.resize();
                    _this.setState({
                        hasloaded: true
                    });
                    // 
                }, function (xhr) {
                    // 
                }, 
                // called when loading has errors
                function (error) {
                });
            }
        };
        _this.start = _this.start.bind(_this);
        // this.onChange = this.onChange.bind(this)
        // this.exposureChange = this.exposureChange.bind(this)
        // this.ambientChange = this.ambientChange.bind(this)
        // this.directChange = this.directChange.bind(this)
        // this.gammaChange = this.gammaChange.bind(this)
        _this.animate = _this.animate.bind(_this);
        _this.setCamera = _this.setCamera.bind(_this);
        // this.stop = this.stop.bind(this)
        _this.onhover = _this.onhover.bind(_this);
        _this.Leave = _this.Leave.bind(_this);
        // this.ToggleWireframe = this.ToggleWireframe.bind(this)
        _this.ToggleAutoRotate = _this.ToggleAutoRotate.bind(_this);
        // this.init = this.init.bind(this)    
        _this.state = {
            scene: new THREE.Scene,
            addLights: true,
            Onhover: false,
            Center: 0,
            model: _this.props.model,
            wireframe: false,
            directColor: 0xFFFFFF,
            exposure: .7,
            ambientIntensity: _this.props.Aintensity || .3,
            directIntensity: _this.props.Dintensity || 0.8 * Math.PI,
            autorotate: false,
            visible: false,
            gamma: _this.props.gamma || true,
            editMenu: _this.props.edit || false,
            hasloaded: false,
            shouldAnimate: false,
        };
        return _this;
    }
    Scene.prototype.componentDidMount = function () {
        var _this = this;
        if (this.props.model.includes('glb')) {
            var mount_1 = this.mount.current;
            if (mount_1) {
                var width = mount_1.clientWidth;
                var height = mount_1.clientHeight;
                var frameId = '';
                this.camera = new THREE.PerspectiveCamera();
                this.renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
                this.frameId = 0;
                this.content = new THREE.Object3D();
                this.activeCamera = new THREE.PerspectiveCamera();
                this.defaultCamera = new THREE.PerspectiveCamera();
                // this.controls = new OrbitControls(this.camera)
                var camera = new THREE.PerspectiveCamera(75, width / height, 0.1, 1000);
                var renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
                // const controls = new OrbitControls(camera)
                // this.controls = controls
                this.camera = camera;
                // controls.screenSpacePanning = true
                this.state.scene.add(camera);
                // camera.rotation.x = -.7
                // ^^ was 4
                // scene.add(cube)
                //    if (this.props.background === "cubemap"){
                // var background = new THREE.CubeTextureLoader()
                // var path =  './assets/cubemap/'
                //      background.load( [
                //       //  px,
                //       //  nx,
                //       //   py,
                //       //   ny,
                //       //   pz,
                //       //   nz
                //       ], (bg) => {
                //         
                //         this.state.scene.background = bg
                //       })}
                if (this.props.background === 'transparent') {
                }
                else if (this.props.background) {
                    this.state.scene.background = new THREE.Color(this.props.background);
                }
                else {
                }
                renderer.setSize(width, height);
                renderer.physicallyCorrectLights = true;
                // renderer.gamma = this.state.gamma
                // renderer.outputEncoding = THREE.sRGBEncoding
                renderer.gammaFactor = 2.2;
                renderer.toneMappingExposure = this.state.exposure;
                renderer.setPixelRatio(window.devicePixelRatio);
                this.renderer = renderer;
                // controls.enabled = false
                //  controls.autoRotate = this.props.autorotate || this.state.autorotate
                //  controls.autoRotateSpeed = 4.5
                this.loadModel(this.props.model, this.state.scene, this.camera);
                this.animate();
                mount_1.appendChild(this.renderer.domElement);
                mount_1.appendChild(this.renderer.domElement);
                window.addEventListener('resize', function () {
                    var mount = _this.mount.current;
                    if (mount) {
                        _this.resize();
                    }
                });
                window.addEventListener('fullscreenhange', function () {
                    var width = mount_1.clientWidth + 5;
                    var height = mount_1.clientHeight;
                    _this.renderer.setSize(width, height);
                });
                mount_1.addEventListener('touchmove', function (e) {
                    e.preventDefault();
                }, { passive: false });
                mount_1.addEventListener('wheel', function (e) {
                    e.preventDefault();
                }, { passive: false });
            }
        }
        else {
            this.state.scene.remove();
        }
    };
    Scene.prototype.componentWillUnmount = function () {
        if (this.props.model.includes('glb')) {
            var mount = this.mount.current;
            this.stop();
            mount.removeChild(this.renderer.domElement);
            this.renderer.dispose();
        }
    };
    Scene.prototype.start = function () {
        if (!this.frameId) {
            this.frameId = requestAnimationFrame(this.animate);
        }
    };
    Scene.prototype.stop = function () {
        cancelAnimationFrame(this.frameId);
    };
    Scene.prototype.resize = function () {
        var mount = this.mount.current;
        if (mount) { // ensures we dont recieve null error when resizing
            var myclientHeight = mount.clientHeight;
            var myclientWidth = mount.clientWidth;
            this.camera.aspect = myclientWidth / myclientHeight;
            this.camera.updateProjectionMatrix();
            // this.background.style({aspect: this.camera.aspect})
            this.renderer.setSize(myclientWidth, myclientHeight);
            // this.start()
        }
    };
    Scene.prototype.onhover = function () {
        this.setState({
            Onhover: true
        });
        this.animate();
        //  this.controls.enabled = true
        //  const controls = new OrbitControls(this.camera);
        //  this.controls = controls;
        //  
        //  this.controls.target = this.state.scene.children[1].position
    };
    // ToggleWireframe(){
    //   traverseMaterials(this.state.scene.children[1], (material: any) => {
    //     this.setState(prevState => ({
    //       wireframe: !prevState.wireframe
    //     }));
    //     material.wireframe = this.state.wireframe;
    //   });
    // }
    Scene.prototype.ToggleAutoRotate = function () {
        this.setState(function (prevState) { return ({
            autorotate: !prevState.autorotate
        }); });
        //  this.controls.autoRotate = this.state.autorotate
        //  this.controls.autoRotateSpeed = 7
    };
    Scene.prototype.Leave = function () {
        this.setState({
            Onhover: false
        });
        // this.controls.enabled = false
        this.stop();
    };
    // original goes here
    Scene.prototype.renderScene = function () {
        var renderer = this.renderer;
        var mount = this.mount.current;
        //     var rect = mount.getBoundingClientRect()
        //     if ( rect.bottom < 0 || rect.top > mount.clientHeight ||
        //       rect.right < 0 || rect.left > renderer.domElement.clientWidth ) {
        //  return // it's off screen
        //    }
        //    // set the viewport
        //    var width = rect.right - rect.left
        //    var height = rect.bottom - rect.top
        //    var left = rect.left
        //    var bottom = renderer.domElement.clientHeight - rect.bottom
        //    renderer.setViewport( left, bottom, width, height )
        //    renderer.setScissor( left, bottom, width, height )
        var camera = this.state.scene.userData.camera;
        // camera.aspect = width / height; // not changing in this example
        // camera.updateProjectionMatrix();
        // scene.userData.controls.update();
        renderer.render(this.state.scene, camera);
        // this.renderer.render(this.state.scene, this.camera)
    };
    Scene.prototype.animate = function () {
        this.frameId = window.requestAnimationFrame(this.animate);
        // this.controls.update()
        // this.renderScene()
        var scene = this.state.scene;
        var camera = this.camera;
        this.renderer.render(this.state.scene, this.camera);
    };
    Scene.prototype.setContent = function (object) {
        // this.clear();
        object.updateMatrixWorld();
        var box = new THREE.Box3().setFromObject(object);
        var size = box.getSize(new THREE.Vector3()).length();
        var center = box.getCenter(new THREE.Vector3());
        // this.controls.reset()
        object.position.x += (object.position.x - center.x);
        object.position.y += (object.position.y - center.y);
        object.position.z += (object.position.z - center.z);
        // this.controls.maxDistance = size * 10
        this.camera.near = size / 100;
        this.camera.far = size * 100;
        this.camera.updateProjectionMatrix();
        this.camera.position.copy(center);
        this.camera.position.x += size / 2.0;
        this.camera.position.y += 0;
        this.camera.position.z += size / 12.334;
        this.camera.lookAt(center);
        // this.setCamera(this.camera);
        // this.controls.saveState();
        this.state.scene.add(object);
        this.content = object;
        this.setState({ addLights: true });
        this.addLights();
        this.setCamera(this.camera);
        this.start();
    };
    Scene.prototype.addLights = function () {
        var state = this.state;
        var hemiLight = new THREE.HemisphereLight();
        hemiLight.name = 'hemi_light';
        this.state.scene.add(hemiLight);
        var light1 = new THREE.AmbientLight('white', state.ambientIntensity);
        light1.name = 'ambient_light';
        this.camera.add(light1);
        var light2 = new THREE.DirectionalLight(state.directColor, state.directIntensity);
        light2.position.set(0.5, 0, 0.866); // ~60º
        light2.name = 'main_light';
        this.camera.add(light2);
    };
    /**
     * @param {string} name
     */
    Scene.prototype.setCamera = function (name) {
        var _this = this;
        if (name === this.camera) {
            // this.controls.enabled = true;
            this.activeCamera = this.defaultCamera;
        }
        else {
            // this.controls.enabled = true
            this.content.traverse(function (node) {
                if (node.isCamera && node.name === name) {
                    _this.activeCamera = node;
                }
            });
        }
    };
    Scene.prototype.render = function () {
        if (this.props.model.includes('glb')) {
            return (React.createElement("div", { style: { width: this.props.width || '100%',
                    height: this.props.height || '350px',
                    borderStyle: 'solid',
                    borderWidth: '0px' }, ref: this.mount, onMouseOver: this.onhover, onMouseLeave: this.Leave, onTouchStart: this.onhover, onTouchEnd: this.Leave, onDoubleClick: this.ToggleAutoRotate }, this.props.children));
        }
        else {
            return (React.createElement(Img, { width: this.props.width || '', height: this.props.height || '350px', fileName: this.props.model }));
        }
    };
    return Scene;
}(Component));
export { Scene };
export default Scene;



//////////////////
// WEBPACK FOOTER
// ./src/components/img4/Img3.tsx
// module id = 1535
// module chunks = 0 1 2 3